import type { BanWordsData } from './utils';

const ENTRY_ID = 'Se0Sb3wK876tUl8Dq2jUEPE';

let cachedData: BanWordsData | null = null;
let fetchPromise: Promise<BanWordsData> | null = null;

export const fetchBanWords = async (): Promise<BanWordsData> => {
  if (cachedData) return cachedData;

  // 동시 호출 시 중복 fetch 방지
  if (fetchPromise) return fetchPromise;

  fetchPromise = (async () => {
    try {
      const spaceId = process.env.NEXT_PUBLIC_WEEGLOO_SPACE_ID;
      const cdnToken = process.env.NEXT_PUBLIC_WEEGLOO_CDN_TOKEN;
      const url = `https://zep.us/weegloo/cda/v1/spaces/${spaceId}/contents/${ENTRY_ID}?locale=en-US&select=fields.json`;

      const res = await fetch(url, {
        headers: { Authorization: `Bearer ${cdnToken}` },
      });

      if (!res.ok) {
        throw new Error(`Failed to fetch ban words: ${res.status}`);
      }

      const body = await res.json();
      const data: BanWordsData = body.fields?.json || {
        blackList: [],
        whiteList: [],
        isolated: [],
        inner: [],
      };
      cachedData = data;

      return data;
    } finally {
      fetchPromise = null;
    }
  })();

  return fetchPromise;
};
